var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-normal-toggle-chart"},[_c('ve-line',{attrs:{"data":_vm.chartData,"toolbox":_vm.toolbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }